
import { Vue, Options } from 'vue-class-component'
import { useStore } from '@/store'
import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper-bundle.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import { mappingImageDefault } from '@/helpers/mapper'
import { MyCoupon } from '@/model/my-coupon.model'
import { Prop, Watch } from 'vue-property-decorator'
import Modal from '@/interfaces/modal'
import { markRaw } from 'vue'
import DefaultIFrame from '../default-iframe/default-iframe.vue'
import { CampaignList } from '@/interfaces/campaign-info'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import { buildQueryParams } from '@/helpers/encodeURI'

library.add(faChevronRight)

@Options({
  components: {
    Swiper,
    SwiperSlide,
    FontAwesomeIcon,
    QSkeleton
  },
  computed: {
    isLoading() {
      return this.$store.state.campaignInfo.campaign.isLoading
    },
    campaignList() {
      return this.$store.state.campaignInfo.campaign.items
    },
    customerType() {
      return this.$store.state.customer?.customerType
    },
    isRegisterLoading() {
      return this.$store.state.campaignInfo.campaignRegister.isLoading
    }
  }
})
export default class Campaign extends Vue {
  @Prop({ required: true }) pushModal!: (modal: Modal) => void

  store = useStore()
  modules = [FreeMode]
  textViewAll = MyCoupon.VIEW_ALL
  indexRegistering: number | null = null

  @Watch('store.state.campaignInfo.campaignRegister.isLoading')
  onUpdatedIsRegisterLoading(newValue: boolean) {
    this.store.state.campaignInfo.campaignRegister.isLoading = newValue
  }

  @Watch('store.state.campaignInfo.campaign.items')
  onUpdatedCampaignItems(newValue: CampaignList[]) {
    this.store.state.campaignInfo.campaign.items = newValue
  }

  getImage(image: string) {
    return mappingImageDefault(image)
  }

  errorImage(event: any) {
    event.target.onerror = null
    event.target.src = require('../../assets/img/campaign-image-placeholder.svg')
  }

  registerCampaign(id: string, index: number) {
    this.indexRegistering = index
    this.store.dispatch('campaignInfo/fetchCampaignRegister', { token: this.store.state.lineInfo.idToken, campaignId: id })
  }

  openWebCampaign(item?: CampaignList) {
    const name = 'Campaign-Webview'
    this.pushModal({
      name,
      component: markRaw(DefaultIFrame),
      props: {
        name,
        url: `${process.env.VUE_APP_CAMPAIGN_WEBVIEW_URL}/${item?.id ? item.id : ''}`,
        token: this.store.state.lineInfo.idToken,
        queryParameter: 'channel=line',
      },
      isHiddenNavbar: true
    })
    this.updateGAEvent(item)
  }

  handleRedirectApp(item?: CampaignList) {
    this.updateGAEvent(item)

    const queryString = buildQueryParams({
      channel: 'line',
      callbackUrl: window.location.href
    })
    window.location.href = `${process.env.VUE_APP_WEB_REGISTER_URI}?${queryString}`
  }

  updateGAEvent(item?: CampaignList) {
    const customerType = this.store.state.customer?.customerType
    let objEvent = {}
    if (item?.id) {
      objEvent = {
        event: 'mylotuss_coupon_card',
        topic_section: 'campaign',
        component: 'campaign-slide',
        coupon_section: item?.content?.th?.title,
        coupon_type: item?.campaign_name,
        coupon_scope: customerType
      }
    } else {
      objEvent = {
        event: 'mylotuss_see_all',
        topic_section: 'campaign',
        component: 'campaign-title-view-all'
      }
    }
    addGAEvent(objEvent)
  }
}
